import { SpecialtyServiceOptionsEnum } from '@rover/rsdk/src/apiClient/latest/model/specialtyServiceOptionsEnum';
import { ServiceTypeSlug } from '@rover/types/src/ServiceType';

type SpecialtyServiceTypeSlug = Extract<ServiceTypeSlug, SpecialtyServiceOptionsEnum>;

const SPECIALTY_SERVICE_TYPES: ReadonlySet<ServiceTypeSlug> = new Set(
  Object.values(SpecialtyServiceOptionsEnum) as SpecialtyServiceTypeSlug[]
);

const isSpecialtyServiceType = (
  serviceTypeSlug?: ServiceTypeSlug
): serviceTypeSlug is SpecialtyServiceTypeSlug =>
  Boolean(serviceTypeSlug && SPECIALTY_SERVICE_TYPES.has(serviceTypeSlug));

export default isSpecialtyServiceType;
